import * as kenogoAuConfig from './kenogo/au/index.ts';
import * as lottolandUkConfig from './lottoland/uk/index.ts';
import * as lottolandZaConfig from './lottoland/za/index.ts';

const sitesConfig = {
  'kenogo/au': kenogoAuConfig,
  'lottoland/uk': lottolandUkConfig,
  'lottoland/za': lottolandZaConfig,
} as const;

type SupportedAppConfig = keyof typeof sitesConfig;
type SiteConfigUnion = (typeof sitesConfig)[SupportedAppConfig];
type SiteConfig = SiteConfigUnion;

/** Fallback when `NEXT_PUBLIC_APP_CONFIG` is unset. */
const DEFAULT_APP_CONFIG = 'lottoland/uk' as SupportedAppConfig;

function normaliseAppConfigFromEnv(): string | undefined {
  const raw = process.env.NEXT_PUBLIC_APP_CONFIG;
  if (raw === undefined || raw === '' || raw === 'undefined') {
    return undefined;
  }
  return raw;
}

function isSupportedAppConfig(value: string): value is SupportedAppConfig {
  return value in sitesConfig;
}

function getSiteConfig(appConfig?: string): SiteConfig {
  const selectedMarket = (appConfig ?? normaliseAppConfigFromEnv() ?? DEFAULT_APP_CONFIG) as string;

  if (!isSupportedAppConfig(selectedMarket)) {
    throw new Error(`Market config not found for ${selectedMarket}`);
  }

  const selectedConfig = sitesConfig[selectedMarket];

  return selectedConfig;
}

export { DEFAULT_APP_CONFIG, getSiteConfig };
export type { SiteConfig, SupportedAppConfig };
